import { render, staticRenderFns } from "./Entrega.vue?vue&type=template&id=280c5ebb"
import script from "./Entrega.vue?vue&type=script&lang=js"
export * from "./Entrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports